import { useRef } from "react";

import { Grid2 } from "@mui/material";

import { TCourseDocument } from "../../../../@types";
import {
	TViewMediaModalRef,
	ViewMediaModal,
} from "../../../common/ViewMediaModal/ViewMediaModal";
import { useLearning } from "../hooks/useLearning";
import { CourseDocumentImage } from "./CourseDocumentImage";
import { CourseDocumentVideo } from "./CourseDocumentVideo";

export function CourseMedia() {
	const { course } = useLearning();
	const viewMediaModalRef = useRef<TViewMediaModalRef>(null);

	const onClickViewMediaFile = (fileToOpen: TCourseDocument) => {
		if (!course) {
			return;
		}

		const index = course.courseDocuments.findIndex(
			(file) => file.id === fileToOpen.id,
		);
		if (index > -1) {
			viewMediaModalRef.current?.open({ index });
		}
	};

	if (!course) {
		return null;
	}

	return (
		<>
			<div className="course-media-container">
				<Grid2 container>
					{course.courseDocuments.map((file) => {
						if (file.contentType.startsWith("image")) {
							return (
								<Grid2
									key={`${file.id}`}
									size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
									onClick={() => {
										onClickViewMediaFile(file);
									}}>
									<CourseDocumentImage file={file} />
								</Grid2>
							);
						}

						if (file.contentType.startsWith("video")) {
							return (
								<Grid2
									key={`${file.id}`}
									size={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4 }}
									onClick={() => {
										onClickViewMediaFile(file);
									}}>
									<CourseDocumentVideo file={file} />
								</Grid2>
							);
						}

						return null;
					})}
				</Grid2>
			</div>
			<ViewMediaModal
				ref={viewMediaModalRef}
				mediaFiles={course.courseDocuments}
			/>
		</>
	);
}
